<template>
  <div class="flex items-center  h-full">
    <span v-if="hasValue"
      class="py-1 font-medium whitespace-nowrap"
      :title="displayValue">{{ displayValue }}</span>
    <p v-else
      class="shadow text-center bg-gradient-to-br from-gray-200 to-gray-300 rounded-full text-gray-500 flex items-center justify-center text-sm"
      style="height: 30px; width: 30px; text-shadow: 1px 1px 3px #999" title="Not Applicable">–</p>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "PermissionValue",
  computed: {
    displayValue() {
      return this.params.value;
    },
    hasValue() {
      return !!this.params.value && this.params.value !== "Not Applicable";
    },
  },
});
</script>
